window.lazyLoadImages = function lazyLoadImages() {

    $('.js_franchiseLazyLoad').unveil();

    $('.js_simpleLazyLoad.js_withFade').unveil(200, function () {

        $(this).load(function () {
            $(this).addClass('imageLoaded');
        });
    });
}

$(document).ready(function () {
   'use strict';

    lazyLoadImages();
});